// src/Api/api.js
import axios from "axios";

// Base URL for all APIs
const apiClient = axios.create({
  baseURL: "https://quizzyin.com/classify/",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
  },
});

// ------------------------------
// GET
// ------------------------------
export const get = async (endpoint) => {
  try {
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("GET Error:", error);
    throw error;
  }
};

// GET with config (optional)
export const get2 = async (endpoint, config = {}) => {
  try {
    const response = await apiClient.get(endpoint, config);
    return response.data;
  } catch (error) {
    console.error("GET2 Error:", error);
    throw error;
  }
};

// ------------------------------
// POST
// ------------------------------
export const post = async (endpoint, data) => {
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data; // return only the clean data
  } catch (error) {
    console.error("POST Error:", error);
    throw error;
  }
};

// POST2 returns full raw axios response
export const post2 = async (endpoint, data) => {
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error) {
    console.error("POST2 Error:", error);
    throw error;
  }
};

// ------------------------------
// PUT
// ------------------------------
export const put = async (endpoint, data) => {
  try {
    const response = await apiClient.put(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("PUT Error:", error);
    throw error;
  }
};

// ------------------------------
// DELETE
// ------------------------------
export const del = async (endpoint) => {
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    console.error("DELETE Error:", error);
    throw error;
  }
};

export default apiClient;
